import { connect } from "react-redux";

import { AppState } from "../../store";
import { loadCampaigns } from "../../store/campaigns/actions";
import Form from "./Form";

const mapState = (state: AppState) => ({
  isLoading: state.campaigns.loading,
});

const mapActions = {
  loadCampaigns,
};

export default connect(mapState, mapActions)(Form);
